export enum OperationDirection {
  Incoming = 0,
  Outgoing = 1
}
